'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\t', '\n\t', '\n\t', '\n\t', '\n\twhite-space: pre-wrap;\n\tdisplay: inline;\n'], ['\n\t', '\n\t', '\n\t', '\n\t', '\n\twhite-space: pre-wrap;\n\tdisplay: inline;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _text = require('../../../constants/text');

var _colors = require('../../../constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SpanComponent = _styledComponents2.default.span(_templateObject, function (_ref) {
	var bold = _ref.bold;
	return bold && bold === true && 'font-weight: ' + _text.TextSizes.WeightSemiBold + ';';
}, function (_ref2) {
	var italic = _ref2.italic;
	return italic && italic === true && 'font-style: italic;';
}, function (_ref3) {
	var underline = _ref3.underline;
	return underline && underline === true && 'text-decoration: underline;';
}, function (_ref4) {
	var color = _ref4.color;
	return color && 'color: ' + color + ';';
});

var formatters = [{ operator: '[b]', prop: 'bold', value: true }, { operator: '[i]', prop: 'italic', value: true }, { operator: '[u]', prop: 'underline', value: true }, { operator: '[pc]', prop: 'color', value: _colors.Colors.Primary }, { operator: '[sc]', prop: 'color', value: _colors.Colors.Secondary }, { operator: '[tc]', prop: 'color', value: _colors.Colors.Tertiary }, { operator: '[suc]', prop: 'color', value: _colors.Colors.Success }];

var FormattedText = function (_React$Component) {
	_inherits(FormattedText, _React$Component);

	function FormattedText() {
		_classCallCheck(this, FormattedText);

		return _possibleConstructorReturn(this, (FormattedText.__proto__ || Object.getPrototypeOf(FormattedText)).apply(this, arguments));
	}

	_createClass(FormattedText, [{
		key: 'getFormattedText',
		value: function getFormattedText() {
			if (!this.props.text || this.props.text === "" || this.props.text === " ") {
				return null;
			}

			var stringText = '';
			var hasPlaceholders = false;
			if (this.props.text.props && this.props.text.type.displayName === 'FormattedMessage') {
				stringText = this.props.intl.formatMessage(this.props.text.props);
				hasPlaceholders = this.props.text.props.values && Object.keys(this.props.text.props.values).length > 0;
			} else {
				stringText = this.props.text;
			}

			var operators = formatters.map(function (f) {
				return f.operator;
			});
			if (!operators.some(function (x) {
				return stringText.toString().indexOf(x) >= 0;
			})) {
				return this.props.text;
			}

			var textArray = [{
				text: stringText,
				size: undefined,
				bold: undefined,
				italic: undefined,
				underline: undefined,
				color: undefined,
				type: 'text'
			}];

			textArray = this.getTexts(textArray);

			if (hasPlaceholders) {
				textArray = this.processPlaceholders(textArray);
			}

			return this.getOutputText(textArray);
		}
	}, {
		key: 'getTexts',
		value: function getTexts(textArray) {
			var _this2 = this;

			formatters.forEach(function (formatter) {
				textArray = _this2.processTexts(textArray, formatter);
			});

			return textArray;
		}
	}, {
		key: 'processTexts',
		value: function processTexts(textArray, formatter) {
			var newTexts = [];
			var operator = formatter.operator;

			textArray.forEach(function (textElement) {
				if (textElement.type === 'text' && typeof textElement.text === 'string') {
					if (textElement.text.includes(operator)) {
						var parts = textElement.text.split(operator);
						parts.map(function (part, i) {
							var newLabel = {
								size: textElement.size,
								text: part,
								bold: textElement.bold,
								italic: textElement.italic,
								underline: textElement.underline,
								color: textElement.color,
								type: textElement.type
							};

							if (i % 2 === 1) {
								newLabel[formatter.prop] = formatter.value;
							}

							newTexts.push(newLabel);
						});
					} else {
						newTexts.push({
							size: textElement.size,
							text: textElement.text,
							bold: textElement.bold,
							italic: textElement.italic,
							underline: textElement.underline,
							color: textElement.color,
							type: textElement.type
						});
					}
				} else {
					newTexts.push({
						size: textElement.size,
						text: textElement.text,
						bold: textElement.bold,
						italic: textElement.italic,
						underline: textElement.underline,
						color: textElement.color,
						type: textElement.type
					});
				}
			});

			textArray = newTexts;

			return textArray;
		}
	}, {
		key: 'processPlaceholders',
		value: function processPlaceholders(textArray) {
			var _this3 = this;

			var newTexts = [];

			textArray.forEach(function (textElement) {
				var valueTexts = _this3.getSplitText(textElement.text);

				if (valueTexts.length == 1) {
					newTexts.push({
						size: textElement.size,
						text: textElement.text,
						bold: textElement.bold,
						italic: textElement.italic,
						underline: textElement.underline,
						color: textElement.color,
						type: textElement.type
					});
				} else {
					valueTexts.forEach(function (value) {
						if (value.type === 'text') {
							newTexts.push({
								size: textElement.size,
								text: value.text,
								bold: textElement.bold,
								italic: textElement.italic,
								underline: textElement.underline,
								color: textElement.color,
								type: textElement.type
							});
						} else {
							var element = _this3.props.text.props.values[value.text];
							newTexts.push({
								size: textElement.size,
								text: element,
								bold: textElement.bold,
								italic: textElement.italic,
								underline: textElement.underline,
								color: textElement.color,
								type: textElement.type
							});
						}
					});
				}
			});

			return newTexts;
		}
	}, {
		key: 'getSplitText',
		value: function getSplitText(text) {
			var valueTexts = [];

			var str = text.split("{");
			if (str.length == 1) {
				valueTexts.push({ text: text, type: 'text' });
				return valueTexts;
			}

			str.forEach(function (key) {
				if (key.indexOf('}') > -1) {
					var splitKey = key.split("}");
					valueTexts.push({ text: splitKey[0], type: 'placeholder' });
					if (splitKey[1]) {
						valueTexts.push({ text: splitKey[1], type: 'text' });
					}
				} else {
					valueTexts.push({ text: key, type: 'text' });
				}
			});

			return valueTexts;
		}
	}, {
		key: 'getOutputText',
		value: function getOutputText(textArray) {
			var _this4 = this;

			var texts = [];

			textArray.map(function (textElement) {
				if (textElement && textElement.text) {
					if (textElement.type === 'text' && typeof textElement.text === 'string') {
						texts.push(_this4.getStyledSpan(textElement.text, textElement.bold, textElement.italic, textElement.underline, textElement.color));
					} else {
						texts.push(textElement.text);
					}
				}
			});

			return texts;
		}
	}, {
		key: 'getStyledSpan',
		value: function getStyledSpan(text, bold, italic, underline, color) {
			return _react2.default.createElement(
				SpanComponent,
				{ key: Math.random().toString(), bold: bold, italic: italic, underline: underline, color: color },
				text
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return this.getFormattedText();
		}
	}]);

	return FormattedText;
}(_react2.default.Component);

FormattedText.propTypes = {
	intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(FormattedText);